import React, { useRef, useEffect } from 'react';
import ResultAll from "./Result-All";
import ResultFiltered from "./Result-Filtered";
import { SearchByResult, SearchResult, useFetchResultsQuery } from '../redux/api-slice';
import { useAppSelector, useAppDispatch } from '../redux/hooks'
import Loader from '../common/loader';
import { SearchTypes } from '../common/constants';
import Pagination from './pagination';
import { setCurrentPage, setSearchResults } from '../redux/settings/page-settings-slice';
import { useAfterPaintEffect } from '../common/useAfterPaint';

export default function ResultsContainer() {
    const dispatch = useAppDispatch();
    const searchResults = useAppSelector((state) => state.pageSettings.searchResults);
    const searchBy = useAppSelector((state) => state.searchOptions.searchBy);
    const term = useAppSelector((state) => state.searchOptions.term);
    const sortBy = useAppSelector((state) => state.searchOptions.sortBy);
    const operaFilter = useAppSelector((state) => state.searchOptions.operaFilter);
    const currentPage = useAppSelector((state) => state.pageSettings.currentPage);
    const pageSize = useAppSelector((state) => state.pageSettings.perPage);
    const resultsCount = useAppSelector((state) => state.pageSettings.searchResultsCount);
    const isInMaintenanceMode = useAppSelector((state) => state.pageSettings.isInMaintenanceMode);
    const maintenanceModeMessaging = useAppSelector((state) => state.pageSettings.maintenanceModeMessaging);

    const firstLoad = useRef<boolean>(true);
    const { isFetching, isError, data } = useFetchResultsQuery({
        searchBy,
        term,
        sortBy
    }) as any;

    const firstPageIndex = (currentPage - 1) * pageSize;
    const lastPageIndex = firstPageIndex + pageSize;
    const filteredResults = operaFilter ? searchResults?.results.filter(result => result.operaTitle == operaFilter) : searchResults?.results;
    const paginatedSearchResults = filteredResults?.slice(firstPageIndex, lastPageIndex);
    const hasDebutInSearchResults = paginatedSearchResults.some(searchResult =>
        (searchResult as SearchByResult)?.castResults?.some(result => result.debut) ?? false);

    useEffect(() => {
        if (!isFetching) {
            dispatch(setSearchResults(data));
        }
    }, [isFetching, data]);

    useAfterPaintEffect(() => {
        // Use firstLoad to ensure the scroll does not occur on initial page load
        if (!firstLoad.current) {
            document.querySelector('.performance-search-results').scrollIntoView({ behavior: "smooth" });
        }
        firstLoad.current = false;
    }, [currentPage, firstLoad]);

    return (
        <div className="performance-search-results">
            {isFetching ? <Loader /> :
                <>
                    {(!isError && !isInMaintenanceMode) ?
                        <>
                            {paginatedSearchResults.length > 0 ?
                                <>
                                    {

                                        /*RESULTS BY ARTIST OR CHARACTER*/
                                        searchBy == SearchTypes.ARTIST || searchBy == SearchTypes.ROLE ?
                                            <section>
                                                <ul className="performance-search-list-filtered performance-search-list"> {
                                                    paginatedSearchResults.map(result => (
                                                        <ResultFiltered {...(result as SearchByResult)} />))}
                                                </ul>
                                                {
                                                    hasDebutInSearchResults &&
                                                        <p aria-hidden="true" className="performance-detail-legend">* Lyric debut</p>
                                                }
                                            </section>
                                            :
                                            /*RESULTS BY ALL OR BY COMPOSER*/
                                            <ul className="performance-search-list-all performance-search-list"> {
                                                paginatedSearchResults.map(result => (
                                                    <ResultAll {...(result as SearchResult)} />))}
                                            </ul>

                                    }

                                    {
                                        (!operaFilter) &&
                                            <Pagination
                                                className="pagination-bar"
                                                currentPage={currentPage}
                                                totalCount={resultsCount}
                                                pageSize={pageSize}
                                                onPageChange={page => dispatch(setCurrentPage(page))}
                                            />
                                    }
                                </>
                                : <h2 className="h3-style"> No results found. </h2>
                            }
                        </>
                        :
                        <h2 className="h3-style">{ isInMaintenanceMode ? maintenanceModeMessaging : "An error occurred." }</h2>
                    }
                </>
            }
        </div>
    );
}



